import React from 'react'
import { useTranslation } from 'react-i18next'

import { useToastContext } from '../../../../../../contexts'
import { getHandleableError } from '../../../../../../utils/errors/isXiaError'
import { requestDeleteRoleAssignments } from '../../../../roleAssignments/data/api'
import { RoleAssignment } from '../../../data'
import { DeleteAssignees } from './DeleteAssignees'

type Props = {
  setIsRequestRunning: (params: boolean) => void
  assignments: RoleAssignment[]
  visible: boolean
  onHide: () => void
  mutate: () => void
  triggerStatus: (
    isCreateValue: boolean,
    isDeleteValue: boolean,
    location: string,
    retryAfter: string,
  ) => void
}

export const DeleteAssigneesContainer: React.FC<Props> = ({
  setIsRequestRunning,
  assignments,
  visible,
  mutate,
  onHide,
  triggerStatus,
}) => {
  const { t } = useTranslation()
  const { showToast } = useToastContext()

  const deleteRoleAssignment = async (assignees: RoleAssignment[]) => {
    try {
      onHide()
      setIsRequestRunning(true)

      let ids: string[] = []

      assignees.forEach(x => ids.push(x.id))

      const result = await requestDeleteRoleAssignments(ids)

      triggerStatus(false, true, result.locationUrl, result.retry)
    } catch (error) {
      let handleableError = getHandleableError(error)
      let errorMessage = handleableError.message

      // show error toast
      showToast({
        style: {},
        closable: true,
        severity: 'error',
        sticky: true,
        summary: t(
          'roleAssignments.table.delete.dialogAssignees.delete.messages.failure.summary',
        ),
        detail: errorMessage,
      })
    } finally {
      setIsRequestRunning(false)
      mutate()
    }
  }

  return (
    <DeleteAssignees
      onClickHandler={() => deleteRoleAssignment(assignments)}
      isVisible={visible}
      onHide={onHide}
      count={assignments.length}
    />
  )
}
